import DropDownArrow from "./DropDownArrow";
import TruckFixLogo from "./Truckfix-logo";
import Close from "./Close";
import Trash from "./Trash";
import FileIcon from "./FileIcon";
import CheckBoxIcon from "./CheckBoxIcon";

export { DropDownArrow, TruckFixLogo, Close, Trash, FileIcon, CheckBoxIcon };
